// EVERY STEP OF A CLICK, IN ORDER, FROM BOTH SIDES.
//
// Owner, 2026-10-21, after six attempts at "the 3D click does not select the
// tree row": log at every step in React and in the 3D viewer.
//
// Each attempt so far fixed something real and none of them fixed HIS problem,
// because every diagnosis rested on reading code and guessing which step was
// failing. A trace does not guess: it says which step ran, with what, and
// where the chain stopped. A gap in the numbers IS the answer.
//
// It writes to the console AND posts one batched line to /client-log, so I can
// read a failure from the server without asking him to copy anything. One
// report per click, not one per step - a step is cheap, a POST is not.
import { reportClientError } from "./clientLog";

let seq = 0;

export function startTrace(label) {
  seq += 1;
  const id = `${label}#${seq}`;
  const t0 = (typeof performance !== "undefined" && performance.now) ? performance.now() : Date.now();
  const steps = [];
  let ended = false;
  const api = {
    id,
    /** One step. `data` must be small and already plain - this is a log, not a dump. */
    step(name, data) {
      const at = Math.round(((typeof performance !== "undefined" && performance.now) ? performance.now() : Date.now()) - t0);
      steps.push({ n: steps.length + 1, name, at, ...(data === undefined ? {} : { data }) });
      // eslint-disable-next-line no-console
      console.log(`[trace ${id}] ${steps.length}. ${name}`, data === undefined ? "" : data);
      return api;
    },
    /** The last step; sends the whole chain once. Safe to call twice. */
    end(outcome, data) {
      if (ended) return api;
      ended = true;
      api.step(`END: ${outcome}`, data);
      try {
        // 380 WAS A GUESS AND IT THREW AWAY THE ANSWER. The server used to clip
        // at 400, so this matched it - and the result was four reported clicks
        // that all stopped at step 4, which is before everything this trace is
        // for. The server now gives trace/* room; send the whole chain. The cap
        // that remains is a size guard, not a window.
        reportClientError(`trace/${label}`, { message: JSON.stringify({ id, outcome, steps }).slice(0, 7000) });
      } catch (e) { /* a trace must never be the error */ }
      return api;
    },
  };
  api.step("start");
  return api;
}

// A TRACE THAT IS NEVER ENDED IS ITSELF A FINDING: the chain stopped somewhere
// without returning. This closes one that has been left open, so the steps
// that DID run are still reported rather than lost with the page.
export function endOpenTraces(trace, outcome) {
  try { if (trace && typeof trace.end === "function") trace.end(outcome || "abandoned"); } catch (e) { /* never throw */ }
}
